<template>
 <div class="page">
    <login-navigator></login-navigator>
    <logo-header></logo-header> 
    <section class="main">
        <div class="banner-content">
            <img src="../assets/banner.jpg" alt="">
        </div>
        <div class="des">
            <h4>广州燊业互联网有限公司介绍</h4>
            <p>广州市燊业互联网有限公司成立于2016年12月29日，公司注册在广州市越秀区。广州市燊业互联网有限公司旗下的www.gzshenye.com网站融合海量生活信息，免费发布查询。立志成为国内领先的生活分类信息网站，为用户提供更好的服务。 
 www.gzshenye.com网站为用户提供房屋租售、全职招聘、兼职招聘、求职简历、交友活动、宠物、生活服务、车辆买卖与服务、二手物品等多种生活信息。涉及日常生活的方方面面信息资讯，都可以在www.gzshenye.com上找到。 
 广州市燊业互联网有限公司为您提供最有效的市场营销效果以及客户关系管理等多方面服务。 </p>
        </div>
    </section>
 </div>
</template>

<script>
import LoginNavigator from "@/components/LoginNavigator";
import LogoHeader from "@/components/LogoHeader";
export default {
  data() {
    return {};
  },
  components: {
    LoginNavigator,
    LogoHeader
  }
};
</script>

<style scoped>
.page {
  background: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}
.main .banner-content {
  padding-top: 40px;
  text-align: center;
}
.main .banner-content .des {
}
.main .des h4 {
  font-size: 20px;
  color: #00a0e9;
  text-align: center;
  padding: 36px 0;
}
.main .des p {
  padding: 0 20px 100px 20px;
  color: #333333;
  font-size: 18px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue